import axios, { CancelToken } from 'axios';
import { Specialty } from 'interfaces/specialty';
import getPractitionerName from 'utils/getPractitionerName';

interface IPractitioner {
  id: string;
  firstName: string;
  lastName: string;
  avatar: string;
  specialties: Specialty[];
  rating: number;
  reviewCount: number;
  name: string;
  title: string;
  specialist: string;
  insurance?: {
    id: string;
    doctorId: string;
    isInNetwork: boolean;
  } | null;
}

interface IGetPractitionerOptions {
  data: IPractitioner[];
}

const mapPractitionerOptions = (data: IPractitioner) => ({
  id: data.id,
  title: getPractitionerName(data),
  avatar: data.avatar,
  specialties:
    data.specialties && Array.isArray(data.specialties) ? data.specialties : [],
  rating: data.rating,
  reviewCount: data.reviewCount,
  insurance: data.insurance,
});

export const getPractitionerOptions = async ({
  clinicId,
  serviceId,
  sortBy,
  cancelToken,
  shouldFetchSplitSchedulingDoctors,
  code,
  serviceSlugName,
  insuranceId,
}: {
  clinicId: string;
  serviceId: string;
  sortBy?: string;
  cancelToken?: CancelToken;
  shouldFetchSplitSchedulingDoctors?: boolean;
  code?: string | null;
  serviceSlugName?: string | null;
  insuranceId?: string;
}) => {
  const res = await axios.get<IGetPractitionerOptions>(
    `clinics/${clinicId}/practitioners`,
    {
      baseURL: process.env.REACT_APP_AXIOS_BE_URL,
      params: {
        id: clinicId,
        sort: sortBy ? 'asc,asc' : 'asc',
        sortBy: sortBy ? `${sortBy},firstName` : 'firstName',
        serviceId,
        ...(code && { code }),
        ...(serviceSlugName && { serviceSlugName }),
        ...(shouldFetchSplitSchedulingDoctors && {
          shouldFetchSplitSchedulingDoctors,
        }),
        ...(insuranceId && { insuranceId }),
      },
      cancelToken,
    }
  );

  return res.data.data.map((item) => mapPractitionerOptions(item));
};
